import React from 'react';

import { questionnairesTypes, tokenTypes, collectAnswersTypes } from './actions'


const initialState = {
    isFetching: false,
	answers: {}
}


export function questionnaires(state = initialState, action) {

    switch(action.type) {

        case questionnairesTypes.REQUEST_TO_PDF:
        case questionnairesTypes.REQUEST:
            state = {...state}
            state.isFetching = true
            return state

        case questionnairesTypes.RECEIVE:
            state = {...state, isFetching: false}
            state.data = action.data
            return state

        case questionnairesTypes.RECEIVE_TO_PDF:
            state = {
                ...state, 
                isFetching: false,
                ...action.data
            }
            return state

        case tokenTypes.REQUEST:
			state = {...state}
			state.isFetching = true
			return state

        case tokenTypes.RECEIVE:
			state = {...state}
			state.token = action.data.token
            state.createdAt = action.data.createdAt
            state.customer_signing_url = action.data.customer_signing_url
			state.isFetching = false
			return state

        case collectAnswersTypes.SET_ANSWER:
			state = { ...state }
			// If nothing has been filled out by customer
			if(state.answers[action.customerId] === undefined) {
				state.answers[action.customerId] = {
					[action.questionnaireId]: {
                        [action.key]: action.value
					}
				}
			} 
			// If customer has answered another questionnaire but this is a first for this questionnaireId
			else if (state.answers[action.customerId][action.questionnaireId] === undefined){
				state.answers[action.customerId][action.questionnaireId] = {
					[action.key]: action.value
				}
			} 
			// Customer has answered a question in this questionnaire (even the same)
			else {
				state.answers[action.customerId][action.questionnaireId][action.key] = action.value
			}
			return state


        case collectAnswersTypes.DELETE_ANSWER:
            state = { ...state }

            // Only done for questions that are arrays (key: []), most answers are (key: value) pairs
            state.answers[action.customerId][action.questionnaireId][action.key].splice(action.index, 1)

            return state

        case collectAnswersTypes.EXPORT_ANSWERED_QUESTIONS:
            state = { ...state }
            state.isFetching = true
            return state

        case collectAnswersTypes.RECEIVE:
            state = { ...state }
            state.isFetching = false
            state['answered'] = action.data
            return state

        default:
            return state
    }
}